import CertificateDao from '../dao/certificate.dao';
import type { Environment } from '../interfaces/environment';

export abstract class CertificateService {
  static fetchInfo(
    env: Environment,
    level: number,
    contactId?: string
  ): Promise<{
    imageUrl: string;
    shareableLink: string;
  }> {
    if (!contactId) {
      throw new Error('Missing contactId');
    }
    if (!level) {
      throw new Error('Missing level');
    }
    return CertificateDao.fetchInfo(env, level, contactId);
  }

  static getCertificateDownloadUrl(
    env: Environment,
    level: number,
    contactId?: string
  ) {
    if (!contactId) {
      throw new Error('Missing contactId');
    }
    if (!level) {
      throw new Error('Missing level');
    }
    return CertificateDao.getCertificateDownloadUrl(env, level, contactId);
  }
}
